/**
 * Number of Wei in one Gwei (10^9)
 *
 * @see https://voltaire.tevm.sh/primitives/denomination for Denomination documentation
 * @since 0.0.0
 */
export const WEI_PER_GWEI = 1_000_000_000n;

/**
 * Number of Gwei in one Ether (10^9)
 *
 * @see https://voltaire.tevm.sh/primitives/denomination for Denomination documentation
 * @since 0.0.0
 */
export const GWEI_PER_ETHER = 1_000_000_000n;
